import React, {useEffect, useState} from "react";
import catalogStyles from './../mainFlyersCatalog/flyersCatalog.module.scss'
import styles from './archiveFlyersCatalog.module.scss';

import {ReactComponent as DeleteIcon} from "../../../../assets/editors/delete_icon.svg";
import {ReactComponent as ArchiveIcon} from "../../../../assets/editors/archive_icon.svg";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {FlyerDto, FlyersStateForArchiveAndDeletedFlyersDto} from "../../../../dtos";
import {history} from "../../../../helpers/history";
import {getFlippingFlyer, getFlyers} from "../../../../store";
import {ActionType} from "../../../../store/actionTypes";
import {ArchiveFlyer} from "./archiveFlyer/archiveFlyer";
import {PageSpinner} from "../../../com/pagesTab/pagesSpinner/spinner";
import envManager from "../../../../com/envManager/EnvManager";
import {
    archiveFlyer,
    clearFlyersData,
    softDeleteFlyer
} from "../../../../store/actionCreators/flyersActionCreators";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_DISABLE_TABS,
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE
} from "../../../../globals/EventDispatcher";
import StatusPopup, {StatusPopupType} from "../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../pages/getSetttingsForPopup";
import {setSelectedPageForTabs} from "../../../../store/actionCreators/pagesActionCreators";
import {resetFlyerState} from "../../../../store/actionCreators/flippingFlyerActionCreators";
import {makeStyles} from "@mui/styles";
import {Box, Button, Checkbox, Grid, Typography} from "@mui/material";

const useStyles = makeStyles(() => ({
    headerContainer: (props: any) => ({
        // height: props.height,
        display: 'flex',
        justifyContent: 'space-between',
        padding: "8px 12px",
        backgroundColor: "#FFFFFF",
        fontSize: "14px",
        minHeight: "50px",
        alignItem: 'center'

    }),
    headerItem: {
        alignItems: 'center'
    },
    boxes: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        width: '100%',
        // justifyContent: 'center',
        '&.leftControls': {
            justifyContent: 'flex-start',
        },
        '&.rightControls': {
            justifyContent: 'space-around',
            '& > .MuiButton-root': {
                '&:hover': {
                    opacity: `0.5`
                }
            }
        }
    },
    urlBox: {
        fontWeight: "bold",
        margin: "5px",
        cursor: "pointer"
    },
    buttonLeftSide: {
        border: `none`,
        background: `inherit`,
        alignItems: `center`,
        position: `relative`,
        maxHeight: `20px`,
        padding: `0`,
    },
    counterWrapper: {
        border: `1.5px solid #616161`,
        position: `absolute`,
        bottom: `-7px`,
        right: `-12px`,
        width: `auto`,
        overflow: `hidden`,
        /* overflow-wrap: break-word; */
        textOverflow: `ellipsis`,
        // padding: `0 10px`,
        maxWidth: `50px`,
        minWidth: `25px`,
        borderRadius: `20px`,
        textAlign: `center`,
        fontSize: `10px`,
        lineHeight: `11px`,
        /* letter-spacing: 0.2em; */
        background: `white`,
        fontStyle: `normal`,
        fontWeight: `normal`,
        color: '#000000'
    },
}));

export const ArchiveFlyersCatalog = () => {
    const dispatch = useDispatch();

    const styleProps = {};
    const classes = useStyles(styleProps);

    const flyersState = useTypedSelector((state) => state.flyers);
    const flyerDetails = useTypedSelector((state) => state.flippingFlyer);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const [state, setState] = useState<FlyersStateForArchiveAndDeletedFlyersDto>({
        archiveCount: 0,
        softDeleteCount: 0,
        isSoftDelete: false,
        flyersData: [],
        showLoader: true,
        activeFlyers: [],
        lastActivatedFlyer: {},
        url: '',
        isModalPopup: false
    })
    const [deleteIDs, changeDeleteIDs] = useState<number[]>([]);
    let {isShowCreateNewFlyerPopup} = useTypedSelector((state) => state.toggleActionsForFlyers);

    useEffect(() => {
        if (state.activeFlyers.length === 1) {
            try {
                // dispatch(clearDataForFlyer());

                let flyerAppAddress = envManager.flyerAppAddress

                let currentFlyerStatus = state.activeFlyers[0].flyFstRec;
                let statusCaption = currentFlyerStatus?.fstCaption?.toLowerCase()

                let appUrl = '';

                if (statusCaption?.includes('edit')) {
                    appUrl = flyerAppAddress = envManager.getFlyerAppAddressWithEnvPrefix('dev')
                } else if (statusCaption?.includes('qa')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('qa')
                } else if (statusCaption?.includes('published')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('')
                }

                //
                if (appUrl.length !== 0 && state.activeFlyers[0].flyRecId) {
                    let accountName = state.activeFlyers[0].flyAccRec?.accCaption;
                    let flyerName = state.activeFlyers[0].flyCaption;
                    appUrl += `flyer/${accountName}/${flyerName}`
                }

                if (statusCaption?.includes('inactive')) {
                    appUrl = '--'
                }

                // Any way if the current flyer has no job code (RecId) => no flyer app address to show
                if (!state.activeFlyers[0].flyRecId) {
                    appUrl = '--'
                }
                setState({
                    ...state,
                    url: appUrl
                })
            } catch (e) {

            }
        } else {
            if (flyerDetailsState && state.activeFlyers.length === 1) {
                setState({
                    ...state,
                    activeFlyers: [flyerDetailsState],
                    lastActivatedFlyer: flyerDetailsState

                })
            } else {
                setState({
                    ...state,
                    url: "--",
                })
            }

        }
    }, [flyerDetailsState]);

    useEffect(() => {
        const controller = new AbortController();
        if (state.activeFlyers.length === 1) {
            const activeFlyer = state.activeFlyers.find((flyer: FlyerDto) => flyer);
            if (activeFlyer) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, activeFlyer.flyCaption);
                const signal = controller.signal;
                dispatch(getFlippingFlyer(activeFlyer.flyRecId!, signal));
            }
        }
        if (state.activeFlyers.length > 1 || state.activeFlyers.length === 0) {
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '');
            setState({
                ...state,
                url: "--",
            })
        }
        return () => {
            controller.abort();
        };
    }, [isShowCreateNewFlyerPopup, state.activeFlyers]);


    useEffect(() => {
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
        sessionStorage.removeItem("activeFlyersArray");

        return () => {
            dispatch(clearFlyersData());
        }
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', keydownHandlerFlyersArchiveScreen);
        return () => {
            window.removeEventListener('keydown', keydownHandlerFlyersArchiveScreen);
        }
    }, [state])


    useEffect(() => {
        if (flyersState.type === ActionType.GET_FLYERS_SUCCESS) {
            let isDefaultFlyer = false;
            if (flyersState.flyers.length > 0) {
                isDefaultFlyer = true;
                if (flyersState.flyers.length > 0) {
                    dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyersState.flyers[0].flyCaption)
                }
            } else {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '')
            }
            setState({
                ...state,
                showLoader: false,
                archiveCount: flyersState.archivedFlyersCount!,
                softDeleteCount: flyersState.softDeletedFlyersCount!,
                activeFlyers: isDefaultFlyer ? [flyersState.flyers[0]] : state.activeFlyers,
                lastActivatedFlyer: isDefaultFlyer ? flyersState.flyers[0] : state.activeFlyers[0],
                flyersData: isDefaultFlyer ? flyersState.flyers : state.flyersData
            })
        } else if (flyersState.type === ActionType.HARD_DELETE_FLYER_SUCCESS || flyersState.type === ActionType.ARCHIVE_FLYER_SUCCESS) {
            const newFlayerState = state.flyersData.filter(key => {
                let isExist = state.activeFlyers.some(flyer => key.flyRecId === flyer.flyRecId);
                if (!isExist) {
                    return key;
                }
            })
            if (state.isSoftDelete && flyersState.type === ActionType.ARCHIVE_FLYER_SUCCESS) {
                dispatch(softDeleteFlyer(deleteIDs, 'en-Us', true, flyersState));
            }
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '');
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
            setState({
                ...state,
                archiveCount: state.archiveCount! - state.activeFlyers.length,
                activeFlyers: [],
                lastActivatedFlyer: {},
                flyersData: newFlayerState,
                showLoader: false
            })
        } else if (flyersState.type === ActionType.HARD_DELETE_FLYER_ERROR) {
            setState({
                ...state,
                showLoader: false
            })
        } else if (flyersState.type === ActionType.SOFT_DELETE_FLYER_SUCCESS) {
            setState({
                ...state,
                softDeleteCount: state.softDeleteCount + deleteIDs.length
            })
        }

    }, [flyersState]);

    useEffect(() => {
        if (flyerDetails.type === ActionType.GET_FLIPPING_FLYER_COMPLETED && flyersState.type === ActionType.GET_FLYERS_COMPLETED) {
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
        }
        // else if (flyerDetails.type === ActionType.CLEAR_DATA_FROM_FLYER) {
        //     dispatch(getFlippingFlyer(state.activeFlyers[0].flyRecId!));
        // }
    }, [flyerDetails])


    const openFlyerDetails = (rowIndex: number, flyerDto: FlyerDto): void => {
        console.log('rowIndex:' + rowIndex);
        console.log('flyerDto.flyRecId:' + flyerDto.flyRecId);
        history.push(`/flyersCatalog/${flyerDto.flyRecId}`)
    }

    const urlClick = () => {
        window.open(state.url, 'urlFromMainScreen');
    }

    const onSoftDeleteFlyer = () => {
        setState({
            ...state,
            showLoader: true,
            isSoftDelete: true,
        })
        let deleteIds: number[] = [];
        state.activeFlyers.forEach(key => {
            deleteIds.push(key.flyRecId!);
        })
        changeDeleteIDs(deleteIds);
        dispatch(archiveFlyer(deleteIds, 'en-Us', false, flyersState))
    }
    // const onHardDeleteFlyer = () => {
    //     setShowLoader(true);
    //     changeModalStatus(false);
    //     dispatch(softDeleteFlyer(deleteID, 'en-Us', true, flyersState));
    //     dispatch(hardDeleteFlyer(deleteID));
    // }

    const onRestoreFlyer = () => {
        setState({
            ...state,
            showLoader: true
        })
        let deleteIds: number[] = [];
        state.activeFlyers.forEach(key => {
            deleteIds.push(key.flyRecId!);
        })
        dispatch(archiveFlyer(deleteIds, 'en-Us', false, flyersState));
    }

    const doubleClickOnFlayer = () => {
        try {
            const data = {
                selectedTabNum: 1,
                pageNo: 0
            }
            dispatch(setSelectedPageForTabs(data));
        } catch (e) {

        }
    }

    const keydownHandlerFlyersArchiveScreen = (e: any) => {
        if (e.code === 'KeyA' && e.ctrlKey && !isShowCreateNewFlyerPopup) {
            e.preventDefault();
            const isSelectedAll = state.activeFlyers.length !== flyersState.flyers.length;
            selectAllPossiblePromosInFramesOrDeselectAll(isSelectedAll);
        }
    }

    const selectAllPossiblePromosInFramesOrDeselectAll = (isSelectedAll: boolean) => {
        if (isSelectedAll) {
            setState({
                ...state,
                activeFlyers: flyersState.flyers,
                lastActivatedFlyer: flyersState.flyers[0]
            })
        } else {
            setState({
                ...state,
                activeFlyers: [],
                lastActivatedFlyer: flyersState.flyers[0]
            })
        }
        dispatch(resetFlyerState());

    }

    const handleChangeSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isSelected = event.target.checked;
        selectAllPossiblePromosInFramesOrDeselectAll(isSelected);
    }

    const flyers = state.flyersData.map((key, index) => {
        // if (activeFlyer !== '') {
        const isActivePage = state.activeFlyers.some((value: any) => value.flyCode === key.flyCode);
        return <ArchiveFlyer key={key.flyCode} flyerDto={key}
                             isActive={isActivePage}
            // setActiveFlyer={setActiveFlyer}
                             flyersState={state}
                             changeFlyersState={setState}
                             openFlyerDetails={openFlyerDetails}
                             flyerIndex={index + 1}
                             onSoftDeleteFlyer={onSoftDeleteFlyer}
            // onHardDeleteFlyer={onHardDeleteFlyer}
                             onRestoreFlyer={onRestoreFlyer}
                             doubleClickOnFlyer={doubleClickOnFlayer}
        />
        // }
    });

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: 'confirmHardDeleteFlyer',
        confirmOnClick: {
            // onHardDeleteClick: onHardDeleteFlyer,
        }
    };


    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <div className={`${catalogStyles.container} ${styles.archive}`}>
            {
                state.showLoader && <div className={catalogStyles.loading}>
                    <PageSpinner/>
                </div>
            }
            <Grid className={classes.headerContainer} container>
                <Grid item className={classes.headerItem} xs>
                    <Box className={classes.boxes}>
                        <Typography fontWeight={900}>
                            Archived Flyers
                            {/*URL: {state.url}*/}
                        </Typography>
                        {/*<div>*/}
                        {/*    URL:*/}
                        {/*</div>*/}
                        {/*<div className={classes.urlBox} onClick={urlClick}>*/}
                        {/*    {state.url}*/}
                        {/*</div>*/}
                    </Box>
                </Grid>
                <Grid item className={classes.headerItem} xs={2}>
                    <Box sx={{
                        display: `flex`,
                        alignItems: `center`,
                        height: "100%",
                        // backgroundColor: `white`,
                        padding: `2px 5px`,
                        justifyContent: `flex-end`
                    }}
                    >
                        <Checkbox
                            checked={state.flyersData.length !== 0 && state.flyersData.length === state.activeFlyers.length}
                            disabled={state.flyersData.length === 0}
                            onChange={handleChangeSelectAll}
                            // checkedIcon={<CheckedIcon />}
                            inputProps={{'aria-label': 'controlled'}}
                            sx={{
                                padding: `0`,
                                marginRight: `5px`,
                            }}
                        />
                        <Typography sx={{
                            // marginRight: `5px`,
                            lineHeight: `15px`,
                            color: `black!important`,
                            opacity: flyerDetailsState.flyFstRec.fstCaption === "Published" || state.flyersData.length === 0 ? `0.5` : `1`
                        }}>
                            Select all
                        </Typography>
                    </Box>
                </Grid>
                <Grid item className={classes.headerItem} xs={1}>
                    <Box className={`${classes.boxes} rightControls`}>
                        <Button
                            title={`Archived Flyer`}
                            className={classes.buttonLeftSide} onClick={() => {
                            dispatch(getFlyers(true, false));
                            history.push('/flyersCatalog/archive');
                        }}>
                            <ArchiveIcon/>
                            <div className={classes.counterWrapper}>
                                {state.archiveCount}
                            </div>
                        </Button>
                        <Button
                            title={`Deleted Flyer`}
                            className={classes.buttonLeftSide} onClick={() => {
                            dispatch(getFlyers(false, true));
                            history.push('/flyersCatalog/trash');
                        }}>
                            <DeleteIcon/>
                            <div className={classes.counterWrapper}>
                                {state.softDeleteCount}
                            </div>
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <div className={catalogStyles.content}>
                {flyers}
            </div>

            {state.isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={state.isModalPopup}
                handleClose={() => setState({...state, isModalPopup: false})}
            />
            }
        </div>
    )
}